import { combineReducers } from 'redux';
import loginReducer from '../screen/auth/reducer';
import distributorReducer from '../screen/distributor/reducer';
import orderReducer from '../screen/distributor/reducer/orderReducer';
import fmcgReducer from '../v2/FMCG/reducer/fmcgReducer';
import firmOnbaordingReducer from '../v2/Onboarding/Reducers/firmOnboardingReducer';
import bcmOrderReducer from '../v2/BCMReducer.js/BCMReducer';
import reportReducer from '../v2/Reports/Reducer/reducer';
import performanceReducer from '../v2/Performance/reducer/reducer';
import rewardsReducer from '../v2/Benefits/Rewards/Reducer/RewardsReducer';
import mainMenuReducer from '../v2/GlobalSidebar/Reducers/PWAMenuReducer';
import entityReducer from '../v3/Common/Entity/reducer/reducer';
import shopReducer from '../v3/Beneficiary/ShopInsurance/reducer/reducer';
import nomineeReducer from '../v2/Benefits/Beneficiary/reducer/nomineeReducer';
import beneficiaryReducer from '../v2/Benefits/Beneficiary/reducer/beneficiaryReducer';
import dpReducer from '../v3/Reducers/DPReducer/dpReducer';

const appReducer = combineReducers({
  loginReducer,
  distributorReducer,
  orderReducer,
  fmcgReducer,
  beneficiaryReducer,
  nomineeReducer,
  firmOnbaordingReducer,
  bcmOrderReducer,
  reportReducer,
  performanceReducer,
  rewardsReducer,
  mainMenuReducer,
  entityReducer,
  shopReducer,
  dpReducer 
});
const initialState = appReducer({}, {});

const rootReducer = (state, action) => {
  if (action.type == 'LOGOUT') {
    localStorage.clear();
    return appReducer(initialState, action);
  } else {
    return appReducer(state, action);
  }
};

export default rootReducer;
